'use client';

import { SectionContainer } from '@/components/ui';
import { Skeleton } from '@/components/ui/Skeleton';

export function RodentInfestationSectionSkeleton() {
  return (
    <SectionContainer>
      <Skeleton className="h-7 w-80 mb-2" />
      <Skeleton className="h-5 w-48 mb-4" />

      <div className="flex items-center gap-3 p-4 rounded-lg bg-secondary">
        <Skeleton className="w-5 h-5 rounded-full shrink-0" />
        <Skeleton className="h-5 flex-1" />
      </div>

      <Skeleton className="h-5 w-40 mt-4" />
    </SectionContainer>
  );
}
